export const TRADEOFF_URL = "https://tradeoff.blueshuckconsulting.com";
export const REGISTER_URL = "https://tradeoff.blueshuckconsulting.com/register";
export const SUPPORT_EMAIL = "support@blueshuckconsulting.com";
export const COMPANY = "Blue Shuck Consulting LTD";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ASSETS = {
  wolfNavy:
    "https://static.prod-images.emergentagent.com/jobs/8606b3bc-87f4-4513-b3e9-b2232d966c63/images/923da17b1df991d5361b5d12cc7c4e68ce914229921e0e89ec4063718bf028eb.png",
  logoWhite:
    "https://static.prod-images.emergentagent.com/jobs/8606b3bc-87f4-4513-b3e9-b2232d966c63/images/a93302a09976e04d441f7332bf5759d1b6cfe7ebfc687bbc580959abad587393.png",
  heroBuilding: "/images/hero-building.jpg",
  aboutBlueprint: "/images/about-blueprint.jpg",
  servicesTeam: "/images/services-team.jpg",
  tradeoffMockup:
    "https://static.prod-images.emergentagent.com/jobs/8606b3bc-87f4-4513-b3e9-b2232d966c63/images/dffdb1054ed72f1e0da9ede62ea10486216659dc843d5fcaeeb1c02ccfd35bb4.png",
};

export const NAV_LINKS = [
  { id: "home", label: "Home", target: "home" },
  { id: "services", label: "Services", target: "services" },
  { id: "about", label: "About", target: "about" },
  { id: "featured-product", label: "Trade Off", target: "featured-product" },
  { id: "pricing", label: "Pricing", target: "pricing" },
  { id: "websites", label: "Websites", target: "managed-websites" },
  { id: "blog", label: "Blog", route: "/blog" },
  { id: "contact", label: "Contact", target: "contact" },
];
